import script from "./CustomerProductReturnList.vue?vue&type=script&setup=true&lang=ts"
export * from "./CustomerProductReturnList.vue?vue&type=script&setup=true&lang=ts"

import "./CustomerProductReturnList.vue?vue&type=style&index=0&id=c5e93ff8&lang=scss"

const __exports__ = script;

export default __exports__